import $ from 'jquery'

/**
 * Company page results filters
 */
export default function doFilters() {
  const $filters = $('.js-select-filters .js-filter')

  const $options = $('.js-select-filters option')

  $filters.change( onFilterSelect )

  onPageInit()

  /**
   * Add the selected filter param to the URL.
   */
  function onFilterSelect() {
    const filterName = $(this).attr('name')
    const optionValue = $('option:selected',this).val()
    var url = ""

    if ($(this).attr('data-type') == "link") {
      url = optionValue
    } else {
      url = new URL(window.location.href)
      url.searchParams.set(filterName, optionValue)
    }
    window.location.href = url;
  }

  /**
   * Select the given Option.
   *
   * @param {Object} $filter The jQuery object filter.
   * @param {string} value The option value.
   */
  function setSelectedOption($filter, value) {
    $('option', $filter).each(function() {
      if (this.value === value) {
        this.selected = 'selected'
      }
    })
  }

  /**
   * Select the filters values depending on the URL params.
   */
  function onPageInit() {
    var url = new URL(window.location.href)

    $($filters).each(function() {
      const param = url.searchParams.get($(this).attr('name'))
      if (param) {
        setSelectedOption($(this), param)
        $(this).addClass('selected');
      }
    });

    $($options).each(function() {
      const url = document.location.href
      if (url == $(this).attr('value') && !$(this).attr('name').includes(": All") ) {
        $(this).attr('selected', true);
        $(this).parent().addClass('selected');
      }
    });

  }
}